<script lang="ts">
    import { createEventDispatcher } from "svelte"

    import ProductQuantity from "./widgets/ProductQuantity.svelte"
    import { mdiDeleteCircle } from "@mdi/js"
    import Icon from "../../widgets/Icon.svelte"
    import ProductPricetags from "./widgets/ProductPricetags.svelte"
    export let item: BKDFCartItem
    const product = item.merchandise.product

    const dispatcher = createEventDispatcher()
</script>

<section class="productCartPreview">
    <div class="imageContainer">
        <img
            src="{product.featuredImage.url}"
            alt="{product.featuredImage.altText}"
        />
    </div>
    <div class="informations">
        <section class="details">
            <h5>{product.title}</h5>
            <small>{item.merchandise.selectedOptions?.map((o) => o.value).join(" | ")}</small>
            <div class="">
                <ProductPricetags
                    product="{product}"
                    smallVersion="{true}"
                />
                <div class="actions">
                    <ProductQuantity on:updateQuantity="{(e) => dispatcher('updateQuantity', e.detail)}" />
                    <button on:click="{() => dispatcher('remove')}"><Icon path="{mdiDeleteCircle}" /></button>
                </div>
            </div>
        </section>
    </div>
</section>

<style lang="less">
    .productCartPreview {
        display: flex;
        gap: 25px;
        height: calc(4.3rem + 24px);
        width: 100%;
        padding-bottom: 24px;
        border-bottom: 1px solid var(--bg-300);
        .imageContainer {
            height: 100%;
            width: auto;
            img {
                height: 100%;
                width: 100%;
                object-fit: contain;
            }
        }
        .informations {
            display: flex;
            justify-content: space-between;
            flex-grow: 1;
            .details {
                display: flex;
                flex-direction: column;
                gap: 10px;
                width: 100%;
                small {
                    color: var(--text-invers-100);
                }
                & > div {
                    display: flex;
                    justify-content: space-between;

                    .actions {
                        display: flex;
                        gap: 12px;
                        height: 100%;
                        align-items: flex-end;
                        button {
                            color: var(--text-invers-100);
                        }
                    }
                }
            }
        }
    }
</style>
